/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryDetailsResponse } from './categoryDetailsResponse';

export interface ManagementCategoryResponse { 
    id: string;
    type?: ManagementCategoryResponse.TypeEnum;
    value?: string;
    details?: Array<CategoryDetailsResponse>;
}
export namespace ManagementCategoryResponse {
    export type TypeEnum = 'CONTRACT_NOTICES' | 'CONTRACT_ANNOUNCEMENTS';
    export const TypeEnum = {
        NOTICES: 'CONTRACT_NOTICES' as TypeEnum,
        ANNOUNCEMENTS: 'CONTRACT_ANNOUNCEMENTS' as TypeEnum
    };
}